import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Title} from "@angular/platform-browser";
import {UserService} from "common-domain";
import {TldManagerUserService} from "../../user/services/tld-manager-user.service";
import {emailValidator} from "common-domain";

@Component({
  selector: 'app-recover-user-name-init',
  templateUrl: './recover-user-name-init.component.html',
  styleUrls: ['./recover-user-name-init.component.scss']
})
export class RecoverUserNameInitComponent implements OnInit {

  emailSent: boolean;
  recoverUserNameForm: FormGroup;
  errorMessages: any;

  constructor(private titleService: Title, private formBuilder: FormBuilder, private userService: TldManagerUserService) {
  }

  ngOnInit() {
    this.createForm();
    this.titleService.setTitle('Recover Username');
  }

  onSubmit() {
    const email = this.recoverUserNameForm.getRawValue().email.trim();
    const password = this.recoverUserNameForm.getRawValue().password;

    this.userService.recoveryUserName(email, password).subscribe(data => {
    }, error => {
      this.errorMessages = error;
    }, () => {
      this.emailSent = true;
    });
  }

  private createForm() {
    this.recoverUserNameForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, emailValidator]),
      password: new FormControl('', [Validators.required]),

    });
  }

}
